import React from 'react';
import PropTypes from "prop-types";
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux';
import styles from './HeroPromoText.module.css';
import {ContentCardBase} from "../ContentCardBase";
import * as brazeActions from '../../../../../redux/actions/braze';
import * as elementsActions from "../../../../../redux/actions/elements";
import elementConstant from "../../../../../shared/constants/element";
import * as contentCardConstants
  from "../../../../../shared/constants/contentCards";

class HeroPromoText extends ContentCardBase {

    constructor(props) {
        super(props);

        this.state = {
            animateClass: styles.animate
        };
    }

    componentDidMount() {
        setTimeout(() => {
            this.setState({
                animateClass: styles.animateActive
            });
        }, 100);
    }

    redirectTo = (cardData) => {
      const { location, setHeroContentCardData, openDeliveryWidget } = this.props;
      const url = cardData?.url;

      if (!url) {
        return;
      }

      if(location?.pathname !== '/' || url.startsWith(contentCardConstants.EXTERNAL_URL_PREFIX)) {
        this.handleClick(cardData)
      } else {
        this.recordClick(cardData);
        setHeroContentCardData({contentCardHandleClick: this.handleDeferredClick, contentCardData: cardData});
        if(openDeliveryWidget) {
          openDeliveryWidget()
        }
      }
    }

    render() {
        const { cardData } = this.props;
        const { title, description, extras } = cardData;
        const {
            actionButtonText,
            actionButtonFill,
            actionButtonTextColor,
            mobileImageUrl,
            webImageUrl
        } = extras;
        const { animateClass } = this.state;

        const actionButton = actionButtonText !== undefined ? (
          <button
            type='button'
            onClick={() => this.redirectTo(cardData)}
            tabIndex={0}
            onKeyDown={(e) => e.key === 'Enter' && this.redirectTo(cardData)}
            style={{backgroundColor: actionButtonFill, color: actionButtonTextColor}}
            className={styles.actionButton}
          >
            {actionButtonText}
          </button>
        ) : null;

        return (
          <div className={[styles.templateContainer, animateClass].join(' ')}>
            <div className={styles.row}>
              <picture>
                <source media="(max-width: 767px)" srcSet={mobileImageUrl} />
                <img
                  src={webImageUrl}
                  className={styles.mainImage}
                  alt={title ?? 'Hero promo text background'}
                />
              </picture>
              <div className={styles.imgWrapper}>
                <div className={styles.inner}>
                  <div className={styles.leftChildContainer}>
                    {title && <h2 className={styles.title}>{title}</h2>}
                    {description && <p className={styles.description}>{description}</p>}
                    {actionButton}
                  </div>
                </div>
              </div>
            </div>
          </div>
        );
    }

    /**
     * Handles deeplink click to set scroll on product category section
     * @param {String} anchor - selected product string
     */
    handleDeepLink = (anchor) => {
        const { setProductCategory } = this.props;
        setProductCategory(anchor);
        const element = document.getElementById(anchor);
        let scrollDelta = this.categoryElement.current ? this.categoryElement.current.getBoundingClientRect().height : elementConstant.scrollDeltaDefaultHeight;
        scrollDelta = window.innerWidth > 768 ? scrollDelta : elementConstant.scrollDeltaDefault;
        const yPos = element ? (element.offsetTop - scrollDelta) : null;
        if (yPos) window.scrollTo({ top: yPos, left: 0, behavior: 'smooth'}); // eslint-disable-line
    }
}

HeroPromoText.propTypes = {
    cardData: PropTypes.shape(
        {
            id: PropTypes.string,
            imageUrl: PropTypes.string,
            title: PropTypes.string,
            description: PropTypes.string,
            url: PropTypes.string,
            linkText: PropTypes.string,
            extras: PropTypes.shape(
                {
                    template: PropTypes.string,
                    actionButtonText: PropTypes.string,
                    actionButtonFill: PropTypes.string,
                    actionButtonTextColor: PropTypes.string,
                    mobileImageUrl: PropTypes.string,
                    webImageUrl: PropTypes.string
                }
            )
        }
    ).isRequired,
    history: PropTypes.shape({
        push: PropTypes.func.isRequired
    }).isRequired,
    onChange: PropTypes.func.isRequired,
    setProductCategory: PropTypes.func.isRequired,
}

export const mapStateToProps = state => {
    const { productCategory, isStickyCategories, menuCategories } = state.elements;
    return { productCategory, isStickyCategories, menuCategories };
}

export const mapDispatchToProps = (dispatch) => ({
  contentCardSession: (value) => dispatch(brazeActions.contentCardSession(value)),
  setProductCategory: (value) => dispatch(elementsActions.setProductCategory(value)),
  setCategoriesPosition: (value) => dispatch(elementsActions.setCategoriesPosition(value)),
  setHeroContentCardData: (value) => dispatch(elementsActions.setHeroContentCardData(value))
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(HeroPromoText));
